import { AlertLevelEnum } from "../enums/alertUsers.enum";
import { SmsHeaderEnum } from "../enums/smsHeader";

export class RunConnectorDto {
    frequency: string;
    alert_level: AlertLevelEnum;
    sms_header: SmsHeaderEnum;

    services: ServiceType[];
    sendMail?: boolean;
    recipients?: string[];
  }
  
  export class ServiceType {
    service_id: string;
    snapshot_id: string;
    // tag_ids?: string[];
    comment?: string;
  }